import { Masonry, Typography } from '@forgeglobal/design-framework';
import ValuationDetailsCard from '@tcs/client-portal-common/components/templates/DetailCards/ValuationDetailsCard';
import useMasonryDynamicColumns from '@tcs/common/hooks/useMasonryDynamicColumns';
import useIsUserRMD from '@tcs/client-portal-common/hooks/useIsUserRMD';
import { AssetValuationsGreeting } from '@tcs/client-portal-common/components/molecules/AssetValuationsGreeting';
import { useStyles } from './AssetValuation.style';
import { AssetValuationDetails } from '@tcs/client-portal-api/types/AssetValuationDetails';

interface AssetValuationProps {
  accountNumber: string;
  valuationData: AssetValuationDetails[];
}

const AssetValuation = ({
  accountNumber,
  valuationData,
}: AssetValuationProps) => {
  const columnNum = useMasonryDynamicColumns('lg', 2);
  const classes = useStyles();

  const isUserRMD = useIsUserRMD(accountNumber);

  // separate assets by those that can be updated in our portal
  // and those that need to be updated by a third party
  let updatableAssets = [];
  if (valuationData) {
    updatableAssets = valuationData.filter((asset) => asset['isUpdateable']);
  }
  return (
    <>
      <AssetValuationsGreeting isUserRMD={isUserRMD} />
      {updatableAssets.length > 0 && (
        <Typography
          variant="h6"
          className={classes.title}
          color="textPrimary"
          data-test-id="asset-title">
          Assets Requiring Self Valuation (Real Estate, Private LLC, Trusts &
          Extraordinary)
        </Typography>
      )}
      <Masonry numCols={columnNum}>
        {updatableAssets.map((asset) => (
          <div key={accountNumber + asset.id}>
            <ValuationDetailsCard accountNumber={accountNumber} asset={asset} />
          </div>
        ))}
      </Masonry>
    </>
  );
};

export default AssetValuation;
